
/**
 * 뉴스 내용 정보
 */
export type GetExploreContent200PageAllOfThreeContentItemContentOneOfFivezeroContent = {
  summary?: string;
};
